import React from 'react'
import '../assets/css/submenu.css'

const Submenu = ({ language, onNavigate }) => {

  const handleSubmenuNavigation = (e, screen) => {
    e.preventDefault()
    onNavigate(e, screen, true) // ส่ง event, screen และ isSubmenu=true
  }
  return (
    <ul className="submenu open">
      <li>
        <div
          className="menu-tab"
          onClick={(e) => handleSubmenuNavigation(e, "projects")}
        >
          {language === "en" ? "All Projects" : "โครงการทั้งหมด"}
        </div>
      </li>
      <li>
        <div
          className="menu-tab"
          onClick={(e) => handleSubmenuNavigation(e, "projects/ArchitectureScreen")}
        >
          {language === "en" ? "Architecture" : "สถาปัตยกรรม"}
        </div>
      </li>
      <li>
        <div
          className="menu-tab"
          onClick={(e) => handleSubmenuNavigation(e, "projects/InteriorScreen")}
        >
          {language === "en" ? "Interior" : "ภายใน"}
        </div>
      </li>
      <li>
        <div
          className="menu-tab"
          onClick={(e) => handleSubmenuNavigation(e, "projects/Constructioncreen")}
        >
          {language === "en" ? "Construction" : "ก่อสร้าง"}
        </div>
      </li>
    </ul>
  );
  
}

export default Submenu